import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Login from "./components/Login/Login";
import Order from "./components/Orders/Order";
import Orderdetails from "./components/Orders/Orderdetails";
import ErrorPage from './GetError';
import AuthCallback from "./components/Login/AuthCallback";
import PDILogin from './components/Login/PdiLogin';
//import Helpdesk from '../../UI/src/help';
import ChangePassword from './components/Login/ChangePassword';

function LocationLogger() {
  const location = useLocation();
  
  useEffect(() => {
    const timestamp = new Date().toISOString();
    const logEntry = `[${timestamp}] ROUTE CHANGE: ${location.pathname}${location.search}`;
    console.log(logEntry);
    
    // Store navigation history
    const existingLogs = localStorage.getItem('navigation_logs') || '';
    localStorage.setItem('navigation_logs', existingLogs + logEntry + '\n');
    
    // Log stack trace to see what triggered the navigation
    console.trace('Navigation triggered by:');
  }, [location]);
  
  return null;
}

function App() {
  console.log("App component rendered at:", new Date().toISOString());
  
  return (
    <div>
      <>
      <BrowserRouter>
        <LocationLogger />
        <Routes>
          <Route exact path="/" element={<Order/>} /> 
         <Route exact path="/OrderDetails" element={<Orderdetails />} />
         <Route exact path="/Login" element={<Login/>} />
         <Route exact path="/Error" element={<ErrorPage/>} />
         <Route exact path="/PDILogin" element={<PDILogin/>} />
         {/* <Route exact path="/Helpdesk" element={<Helpdesk/>} />*/}
         <Route exact path="/ChangePassword" element={<ChangePassword/>} /> 
         <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </BrowserRouter>
      </>
      
    </div>


  );
}

export default App;
